import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import SearchValidation from "./components/pages/search-validations/SearchValidation";

const App = () => {
  return (
    <>
      <Toaster />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </>
  );
};

const AppContent = () => {

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <div className="content-wrapper">
            <Routes>
              <Route path="/search" element={<SearchValidation />} />
            </Routes>
          </div>
          <div className="content-backdrop fade"></div>
        </div>
      </div>
    </>
  );
};

export default App;
